// Persists the user's "don't show again" choice for the 30km route-length warning
// (see RouteLengthWarningModal.vue). Stored per-device in localStorage — a permanent,
// cross-session dismissal (the in-memory routeLengthWarningShown flag only suppresses it
// for the current session).
//
// All access is wrapped so a disabled/full/unavailable localStorage (private mode, quota,
// SSR) degrades to "not dismissed" rather than throwing and breaking the planner.

export const ROUTE_LENGTH_WARNING_DISMISSED_KEY = 'hiiker.planner.routeLengthWarningDismissed';

export function isRouteLengthWarningDismissed(): boolean {
  try {
    return localStorage.getItem(ROUTE_LENGTH_WARNING_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function dismissRouteLengthWarningPermanently(): void {
  try {
    localStorage.setItem(ROUTE_LENGTH_WARNING_DISMISSED_KEY, 'true');
  } catch {
    // localStorage unavailable (private mode / quota) — nothing we can do; the warning
    // will simply reappear next session, which is an acceptable degradation.
  }
}
